// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1jHs-","label":"SetPasswdForm_label__1Yz7J"};